<div class="pdf-dialog">
  <h2 mat-dialog-title>{{ data?.fileName || 'PDF Preview' }}</h2>
  <mat-dialog-content>
    <div class="pdf-container">
      <!-- Embed PDF via <object> using a SafeResourceUrl to avoid pdf.js Fluent resolver issues -->
      <ng-container *ngIf="pdfResourceUrl; else noPdf">
        <object [data]="pdfResourceUrl" type="application/pdf" width="100%" height="100%">
          <p>PDF cannot be displayed. <a [href]="pdfBase64String" download="{{ data?.fileName }}">Download</a></p>
        </object>
      </ng-container>
      <ng-template #noPdf>
        <div>No PDF available to preview</div>
      </ng-template>
    </div>
    <div *ngIf="pdfLoadError" class="pdf-error" style="margin-top: 8px; color: #b00020">
      <p><strong>PDF failed to load:</strong> the base64 data appears invalid or corrupted.</p>
      <p *ngIf="pdfBase64String">
        You can download the raw data URI and open it in a new tab:
        <a [href]="pdfBase64String" target="_blank" rel="noopener" download>{{ data?.fileName || 'file.pdf' }}</a>
      </p>
      <p *ngIf="!pdfBase64String && pdfUrl">
        Or try opening the blob URL: <a [href]="pdfUrl" target="_blank" rel="noopener">Open blob URL</a>
      </p>
      <p>If these links don't work, the stored content is probably not valid PDF base64 — check the document node content.</p>
    </div>
    <div class="pdf-editor-controls">
      <mat-form-field appearance="outline">
        <mat-label>Stamp text</mat-label>
        <input matInput #stampInput />
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="addTextStamp(stampInput.value)">Add stamp</button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
    <button mat-raised-button color="primary" (click)="onSaveEditedPdf()">Save</button>
  </mat-dialog-actions>
</div>
